/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GroupingRuleCostAnomalyImpact {
    getFixupPrototypeFunction() { return GroupingRuleCostAnomalyImpact.fixupPrototype; }

    static newInstance(model: Partial<GroupingRuleCostAnomalyImpact>): GroupingRuleCostAnomalyImpact {
        let obj = Object.assign(new GroupingRuleCostAnomalyImpact(), model);
        GroupingRuleCostAnomalyImpact.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GroupingRuleCostAnomalyImpact>): GroupingRuleCostAnomalyImpact {
        if (!model) return null;
        return GroupingRuleCostAnomalyImpact.newInstance(<GroupingRuleCostAnomalyImpact> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GroupingRuleCostAnomalyImpact) {
        if (!obj) return;

        models.GroupingRuleCostAnomalyImpact.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GroupingRuleCostAnomalyImpact): boolean {
        Object.setPrototypeOf(obj, GroupingRuleCostAnomalyImpact.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.minimum_cost_impact === undefined) {
            this.minimum_cost_impact = 0;
        }
        if (this.minimum_cost_impact_percentage === undefined) {
            this.minimum_cost_impact_percentage = 0;
        }
    }

    /**
     * Minimum cost impact to trigger anomaly detection for this dimension
     */
    minimum_cost_impact: number;

    /**
     * Minimum cost impact to trigger anomaly detection for this dimension
     */
    minimum_cost_impact_percentage: number;

    /**
     * Operator to combine the cost impact conditions
     */
    op: models.CostAnomalyDimensionImpactOperator;

}
